import { reactive } from "@vue/reactivity";
const errors = reactive({});
export default function useFormValidation() {
    const id = makeid(8)

    const validateNameField = (fieldName, fieldValue) => {
        errors[id] = fieldValue === "" ? fieldName + "을 입력하세요" : "";
    }

    function makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    return { errors, validateNameField, id }
}